<template>
    <v-card>
        <v-card-title class="headline">
            {{ticketActivity.user.full_name}}
            <v-chip
                    v-if="ticketActivity.user.is_supporter"
                    small
                    class="ma-2"
                    color="warning"
                    text-color="white"
            >
                پشتیبان نمابر
            </v-chip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-chip
                            v-if="!ticketActivity.user_visibility"
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="ma-2"
                            text-color="white"
                    >
                        پیغام خصوصی
                    </v-chip>
                </template>
                <span>کاربر این پیام را مشاهده نمی کند</span>
            </v-tooltip>
        </v-card-title>
        <v-card-subtitle>{{$t('created_at')}} {{ getJalaliDate(ticketActivity.created_at * 1000) }}</v-card-subtitle>
        <v-card-text v-text="ticketActivity.description"></v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            ticketActivity : {
                required: true
            }
        },
    }
</script>